import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getData } from '../../Actions/DropDown/getData';

class Select extends React.PureComponent {
  state = {
    visible: true,
    options: this.props.options,
  };

  componentWillMount() {
    this.props.getData({ key: this.props.dataKey });
  }

  componentWillReceiveProps(props) {
    // console.log(props);
    if (props.options && props.options.length === 1) {
      this.props.onChange(props.options[0][(props.editable ? 'id' : 'key')]);
      this.setState({ visible: false });
      return;
    }
    this.setState({ visible: true });
  }

  update = (e) => {
    this.props.onChange(e.target.value);
  }

  titleCase = str => str.toLowerCase().split(' ').map(word => (word.charAt(0).toUpperCase() + word.slice(1))).join(' ');

  render() {
    if (!this.state.visible) {
      return (
        <input type="text" disabled value={this.props.options[0].value} className="text-input-field" />
      );
    }

    let visibleStr = 'Select One...';
    if (this.props.placeholder) visibleStr = this.props.placeholder;
    if (this.props.value) visibleStr = this.props.value;
    if (this.props.editable && this.props.options) {
      this.props.options.map((o) => {
        if (this.props.value.toString() === o.id.toString()) visibleStr = this.titleCase(o.value);
        return null;
      });
    }

    return (
      <div className={this.props.value ? 'niceselect-wrapper' : 'niceselect-wrapper niceselect-default'}>
        <span className="niceselect-text">{ visibleStr }</span>
        <select onChange={this.update} value={this.props.value} className="js-nice-select">
          <option value="">Please Select</option>
          { this.props.options.length === 0 ? <option value="">Loading...</option> : null}
          { this.props.options.map(o => (
            <option value={this.props.editable ? o.id : o.key} key={o.id}>
              {this.titleCase(o.value)}
            </option>
          )) }
        </select>
      </div>
    );
  }
}

Select.propTypes = {
  dataKey: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.array.isRequired,
  editable: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
};

Select.defaultProps = {
  placeholder: '',
};

const mapStateToProps = (state, ownProps) => {
  const data = {
    options: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].options : [],
    editable: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].editable : 0,
  };

  if (data.options) data.options.sort((a, b) => (a.value > b.value ? 1 : -1));
  return data;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getData: (p) => { dispatch(getData(p)); },
});

const SelectLink = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Select);

export default SelectLink;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Select.jsx